import { useState } from "react";
import { Button, Card, Empty, Icon, Text } from "@app/ui";
import { useT } from "../i18n.js";
import { CreateOrgModal, useCanCreateOrg } from "./CreateOrgModal.js";

/**
 * Empty state shown by DPP pages when the user belongs to no organization.
 * When the user can provision one (platform admin or self-service enabled) it
 * offers a first-run "create organization" CTA so onboarding is self-evident;
 * otherwise it falls back to a hint to ask a platform administrator.
 */
export function NoOrgState() {
  const t = useT();
  const canCreateOrg = useCanCreateOrg();
  const [open, setOpen] = useState(false);

  return (
    <Card>
      {canCreateOrg ? (
        <Empty description={<Text strong>{t("org.emptyTitle")}</Text>}>
          <Text small secondary>
            {t("org.emptyCtaHint")}
          </Text>
          <Button
            variant="primary"
            icon={<Icon name="plus" size={16} />}
            onClick={() => setOpen(true)}
            style={{ marginTop: "var(--az-sp-3)" }}
          >
            {t("org.create")}
          </Button>
        </Empty>
      ) : (
        <Empty description={t("org.empty")}>
          <Text small secondary>
            {t("org.emptyHint")}
          </Text>
        </Empty>
      )}
      <CreateOrgModal open={open} onClose={() => setOpen(false)} />
    </Card>
  );
}
